"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationMetricsTracker = void 0;
/**
 * A class that deals with operation metrics such as the time it takes to
 * perform an operation.
 */
var OperationMetricsTracker = /** @class */ (function () {
    function OperationMetricsTracker() {
        this._startTime = null;
        this._endTime = null;
    }
    /**
     * Create a new OperationMetricsTracker.
     *
     * @returns OperationMetricsTracker
     */
    OperationMetricsTracker.create = function () {
        return new OperationMetricsTracker();
    };
    /**
     * Start a time measurement.
     */
    OperationMetricsTracker.prototype.start = function () {
        if (this._startTime !== null) {
            throw new Error('Measurement is already in progress.');
        }
        this._startTime = Date.now();
    };
    /**
     * End a time measurement.
     */
    OperationMetricsTracker.prototype.end = function () {
        if (this._startTime === null || this._endTime !== null) {
            throw new Error('Measurement is not in progress.');
        }
        this._endTime = Date.now();
    };
    /**
     * Get the resulting metrics after a measurement has ended.
     *
     * @returns Formatted metrics.
     */
    OperationMetricsTracker.prototype.getMetrics = function () {
        if (this._startTime === null || this._endTime === null) {
            throw new Error('Measurement is not done.');
        }
        return {
            start_time: this._startTime,
            end_time: this._endTime,
        };
    };
    return OperationMetricsTracker;
}());
exports.OperationMetricsTracker = OperationMetricsTracker;
//# sourceMappingURL=operation_metrics_tracker.js.map